module.exports = __webpack_public_path__ + "img/Icon_Espacios_Disponibles.619bfff5.svg";